@if (!dismissed) {
  <div
    class="smily-infobox-shell"
    [class.smily-infobox-shell--signup-promo]="
      smilyContext.displayState === DisplayState.SignupNeeded
    "
  >
    <button
      type="button"
      class="smily-infobox__close"
      aria-label="Schließen"
      (click)="dismiss()"
    >
      ×
    </button>
    @switch (smilyContext.displayState) {
  @case (DisplayState.SignupNeeded) {
    <ng-container
      *ngTemplateOutlet="
        signupPromo;
        context: { titleId: 'smily-signup-title' }
      "
    />
  }
  @case (DisplayState.Member) {
    <section
      class="smily-infobox smily-infobox--member"
      aria-labelledby="smily-member-title"
    >
      <img
        class="smily-infobox__gift"
        src="/resultpage/assets/icons/smily/geschenk.svg"
        alt=""
        width="60"
        height="52"
        aria-hidden="true"
      />
      <div class="smily-infobox__member-body">
        <h2 id="smily-member-title" class="smily-infobox__member-headline">
          {{ memberTitle() }}
        </h2>
        <p class="smily-infobox__member-text">{{ memberText() }}</p>
      </div>
    </section>
  }
    }
  </div>
}

<ng-template #signupPromo let-titleId="titleId">
  <section
    class="smily-infobox smily-infobox--signup"
    [attr.aria-labelledby]="titleId"
  >
    <div class="smily-infobox__signup-mobile">
      <img
        class="smily-infobox__smily-badge"
        src="/resultpage/assets/icons/smily/smily_badge.svg"
        alt="Smily"
        width="58"
        height="23"
      />
      <div class="smily-infobox__signup-mobile-body">
        <h2 class="smily-infobox__signup-mobile-headline">
          Jetzt anmelden und sparen
        </h2>
        <p class="smily-infobox__signup-mobile-text">
          Cashbacks und Punkte sichern.
        </p>
      </div>
      <a class="smily-infobox__signup-mobile-cta" [href]="ctaHref()">
        anmelden
      </a>
    </div>

    <div class="smily-infobox__signup-desktop">
      <img
        class="smily-infobox__gift"
        src="/resultpage/assets/icons/smily/geschenk.svg"
        alt=""
        width="60"
        height="52"
        aria-hidden="true"
      />
      <div class="smily-infobox__signup-body">
        <h2 [id]="titleId" class="smily-infobox__signup-headline">
          Anmelden und sparen
        </h2>
        <p class="smily-infobox__signup-text">
          Sofortiger Zugang zu unserem Smily-Treueprogramm,
          <strong>Cashbacks und Punkte bei einem Abschluss sichern.</strong>
        </p>
        <a class="smily-infobox__signup-cta" [href]="ctaHref()">
          jetzt für Smily anmelden
        </a>
      </div>
    </div>
  </section>
</ng-template>
